import React from "react"
import "./Header.css"

function Header() {
    return (
        <div className="Header">
            <h1 className="title">SPEAR OF ADUN</h1>
            <h2 className="subtitle">StarCraft Artificial Intelligence</h2>
        </div>
    )
}

export default Header